export const Proficiencies = [
  { value: 1, text: 'ضعیف' },
  { value: 2, text: 'متوسط' },
  { value: 3, text: 'خوب' },


]
const ProficiencySetter = (val) => {

  let value = null
  Proficiencies.forEach((el) => {
    if (el.value === val) {
      value = el.text;
    }
  })
  return value;
}
export default ProficiencySetter;
